import { render, staticRenderFns } from "./DashboardCMEmbarcador.vue?vue&type=template&id=ded8a048&scoped=true&"
import script from "./DashboardCMEmbarcador.vue?vue&type=script&lang=js&"
export * from "./DashboardCMEmbarcador.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCMEmbarcador.vue?vue&type=style&index=0&id=ded8a048&scoped=true&lang=css&"
import style1 from "./DashboardCMEmbarcador.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8a048",
  null
  
)

export default component.exports